import * as React from "react";

export interface Props {
  appName: string;
}

class FeedbackLink extends React.Component<Props> {
  render() {
    return (
      <>
        <span>
          Provide{" "}
          <a
            id="feedback-link"
            href={`https://ask.fdic.gov/fdicinformationandsupportcenter/s/fdicdirform?app=${this.props.appName}`}
          >
            feedback or submit a question{" "}
          </a>
          about this page.
        </span>
      </>
    );
  }
}

export default FeedbackLink;
